import styled from "styled-components";

export const HeaderTitle = ({ text, style }) => {
  return <HeaderTitleText style={style}>{text}</HeaderTitleText>;
};

const HeaderTitleText = styled.span`
  white-space: nowrap;
  font-size: var(--18px);
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
`;
